import { createStyles, makeStyles } from '@mui/styles';

export default makeStyles(() =>
  createStyles({
    marginBStyle: {
      '& p':
      { marginBottom: '0px' },
    },
  }),
);
